var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "getCert" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "contentBox" }, [
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "contentBox-right" }, [
        _c("section", { staticClass: "clickZone" }, [
          _vm.nonUserInfo == false
            ? _c("p", { domProps: { innerHTML: _vm._s(_vm.downloadText) } })
            : _vm._e(),
          _vm._v(" "),
          _vm.nonUserInfo == true
            ? _c("p", { domProps: { innerHTML: _vm._s(_vm.downloadText2) } })
            : _vm._e(),
          _vm._v(" "),
          _c("p", [
            _vm.nonUserInfo == false
              ? _c("i", {
                  staticClass: "downloadCert",
                  on: {
                    click: function($event) {
                      _vm.downloadCertBtn(1, 3508, 2481), (_vm.DLclick = 0)
                    }
                  }
                })
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("p", [
            _vm.nonUserInfo == true
              ? _c("i", { staticClass: "downloadCert-non" })
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("p", [
            _vm.DLclick === 0
              ? _c("span", [_vm._v("证书下载中，请稍候...")])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("section", { staticClass: "clickZone" }, [
          _c("p", { domProps: { innerHTML: _vm._s(_vm.continueText) } }),
          _vm._v(" "),
          _c("i", {
            staticClass: "continue",
            on: {
              click: function($event) {
                _vm.continueBtn()
              }
            }
          })
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [_c("h1", [_vm._v("生成证书")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "contentBox-left" }, [
      _c("div", { staticClass: "imgZone" }, [
        _c("img", {
          attrs: {
            src: require("@/assets/images/event/oneHourCode/cert-border.png"),
            id: "sideImg"
          }
        }),
        _vm._v(" "),
        _c("img", { attrs: { id: "mainImg" } })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-723d0fa0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-723d0fa0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ohcGetCert.vue
// module id = null
// module chunks = 